import { revokeCredential } from './states';

export const services = {
  revokeCredential,
};
